<kilowant-header
                 [isBuyer]="true"
                 [showAccountList]="false"
                 title="AI Tasks"></kilowant-header>
<div class="wrapperMain mainAccountDetailsMain accountDetails">
    @if (pageLoaded()) {
    <div class="form buyer">
        @for (aiTask of activeTasks; track aiTask; let i = $index) {
        <div class="account-info-block mt-20">
            <p class="card-block-background" *ngIf="aiTask.level==1">Nonstop Shop Short-Term Savings</p>
            <p class="card-block-background" *ngIf="aiTask.level==2">Nonstop Shop Mid-Term Savings</p>
            <p class="card-block-background" *ngIf="aiTask.level==3">Nonstop Shop Long-Term Savings</p>
            <div class="visible">
                <div class="d-flex">
                    <div class="auto">
                        @if (aiTask.level==1) {
                        <div class="p-10 f13">
                            Captures maximum savings  yield seasonally up to 9 months in the future. Triggers during low, avg, high markets.
                            <div class="price-statistics">
                                <div class="statistics" style="width: 100px;">
                                    <div class="low"></div>
                                    <div class="average"></div>
                                    <div class="high"></div>
                                </div>
                            </div>
                        </div>
                        }
                        @if (aiTask.level==2) {
                        <div class="p-10 f13">
                            Captures maximum savings yield up to 18 months in the future. Triggers during low - avg markets.
                            <div class="price-statistics">
                                <div class="statistics" style="width: 66px;">
                                    <div class="low"></div>
                                    <div class="average"></div>
                                </div>
                            </div>
                        </div>
                        }
                        @if (aiTask.level==3) {
                        <div class="p-10 f13">
                            Captures maximum savings yield up to 36 months in the future. Triggers during low markets.
                            <div class="price-statistics">
                                <div class="statistics" style="width: 33px;">
                                    <div class="low"></div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>

                <p class="subUniqueTitle mt-10">Subscribed Accounts - {{aiTask.accounts.length}} of {{accountsNotInAI.length}}</p>
                <div class="auto">
                    <div class="checkbox-list"><label *ngIf="aiTask.accounts.length>0"><input type="checkbox" [checked]="selectedAll[i*2]" (click)="selectAllAccounts(i*2)"> Select All</label></div>
                    @for (aData of aiTask.accounts; track aData; let p = $index) {
                      <div class="checkbox-list" *ngIf="p<3 || showAllTasks[i*2]"><label><input [checked]="selectedAccounts[i*2].includes(aData.id)" (click)="switchAccountSelection(i*2, aData.id)" type="checkbox"> {{getName(aData)}}</label></div>
                    }
                    <div class="text-right p-10" *ngIf="aiTask.accounts.length>3 && showAllTasks[i*2]"><a class="link" (click)="showAllTasks[i*2]=!showAllTasks[i*2]">show less</a></div>
                    <div class="text-right p-10" *ngIf="aiTask.accounts.length>3 && !showAllTasks[i*2]"><a class="link" (click)="showAllTasks[i*2]=!showAllTasks[i*2]">show all {{aiTask.accounts.length}} accounts</a></div>
                </div>
                <div class="block-buttons full-width p-10 small-buttons" *ngIf="selectedAccounts[i*2]!=null && selectedAccounts[i*2].length>0">
                    <button (click)="switchAI(i*2, 0)">Deactivate</button>
                </div>
                <p class="subUniqueTitle mt-10">Unsubscribed Accounts - {{(accountsNotInAI.length - aiTask.accounts.length)}} of {{accountsNotInAI.length}}</p>
                <div class="auto">
                    <div class="checkbox-list"><label *ngIf="(accountsNotInAI.length - aiTask.accounts.length)>0"><input type="checkbox" [checked]="selectedAll[i*2+1]" (click)="selectAllAccounts(i*2+1)"> Select All</label></div>
                    @for (iData of getAccountsNotInAITask(aiTask, accountsNotInAI); track iData; let p = $index) {
                        <div class="checkbox-list" *ngIf="(p<3 || showAllTasks[i*2+1])"><label><input [checked]="selectedAccounts[i*2+1].includes(iData.id)" [disabled]="aiTask.level!>1 && !iData.hasFullConsumption" (click)="switchAccountSelection(i*2+1, iData.id)" type="checkbox"> {{iData.accountName}}
                                <a (click)="openConsumptionDialog(iData)" *ngIf="aiTask.level!>1 && !iData.hasFullConsumption" class="consumption-edit link"></a>
                            </label>                        
                        </div>
                    }
                    <div class="text-right p-10" *ngIf="(accountsNotInAI.length - aiTask.accounts.length)>3 && showAllTasks[i*2+1]"><a class="link" (click)="showAllTasks[i*2+1]=!showAllTasks[i*2+1]">show less</a></div>
                    <div class="text-right p-10" *ngIf="(accountsNotInAI.length - aiTask.accounts.length)>3 && !showAllTasks[i*2+1]"><a class="link" (click)="showAllTasks[i*2+1]=!showAllTasks[i*2+1]">show all {{(accountsNotInAI.length - aiTask.accounts.length)}} accounts</a></div>
                </div>
                <div class="block-buttons full-width p-10 small-buttons" *ngIf="selectedAccounts[i*2+1]!=null && selectedAccounts[i*2+1].length>0">
                    <button (click)="switchAI(i*2+1, aiTask.level!)">Subscribe</button>
                </div>
                <div>
                    <p class="subUniqueTitle mt-10">Creation Date</p>
                    <p class="mlr-20 f13"> {{aiTask.dateUpdated | date:'shortDate'}} </p>
                </div>
            </div>
        </div>

        <div class="consumption-info" *ngIf="i==0"><span class="icon"></span>
        Nonstop Shop ai Levels 2 and 3 require 12 months of consumption history to properly weight the cost benefit of our price plans. If 12 months of consumption history is not available, you can select Nonstop Shop ai Level 1.
        </div>
        } 
    </div>
    }
</div>